import footerImage from "../../assets/images/footer-icon.svg";

const Footer: React.FC = () => {
  return (
    <footer
      className="w-100 d-flex align-items-center justify-content-end"
    >
      <img src={footerImage} alt="footer-image" />
    </footer>
  );
};

export default Footer;
